import { FillTrackingUserPayload, ReassignUserReducerState, SelectUserPayload } from "../types"

export const fillTrackingRow = (state: ReassignUserReducerState, payload: FillTrackingUserPayload): ReassignUserReducerState => {
    return { ...state, trackingRow: payload.row }
}

export const selectUser = (state: ReassignUserReducerState, payload: SelectUserPayload): ReassignUserReducerState => {
    const { trackingData } = state
    const { userId } = payload
    if (!userId) { return state }
    const { usersToTracking } = trackingData
    const userIsAdded = usersToTracking.includes(userId)
    return {
        ...state,
        trackingData: {
            ...trackingData,
            usersToTracking: userIsAdded ? usersToTracking.filter(user => user != userId) : [...usersToTracking, userId]
        }
    }
}

export const selectAllUsers = (state: ReassignUserReducerState): ReassignUserReducerState => {
    const { trackingData } = state
    const { usersToTracking } = trackingData
    const allUsersAreSelecteds = !state.trackingRow.some(userTracking => !usersToTracking.includes(userTracking.id))
    return {
        ...state,
        trackingData: {
            ...trackingData,
            usersToTracking: allUsersAreSelecteds ? [] : state.trackingRow.map(user => user.id),
        }
    }
}

export const checkCanBossFollowUp = (state: ReassignUserReducerState): ReassignUserReducerState => {
    const { trackingData } = state
    return { ...state, trackingData: { ...trackingData, bossCanFollowUp: !trackingData.bossCanFollowUp } }
}